/**
 * Exhaustiveness guard for closed vocabularies.
 *
 * A `switch` over a closed enum needs no `default` today: `strict` refuses a
 * branch-less path whose return type does not admit `undefined` (TS2366). That
 * protection is a property of the ENUM, not of the switch - the day the
 * vocabulary opens into a slug, the same switch keeps compiling and silently
 * falls through. `assertNever` moves the guard onto the switch itself: while
 * the vocabulary is closed the call cannot be reached and the `never` parameter
 * proves it at compile time; once it opens, an unknown value throws where it
 * used to slip past.
 *
 * The message names the value because the callers are engine paths a session
 * runs through: "unhandled transition" without the offending value sends the
 * reader back to the transcript to guess which one.
 */
export function assertNever(value: never, what: string): never {
  throw new Error(`${what}: unhandled value ${JSON.stringify(value)}`);
}
